module.exports = __webpack_public_path__ + "img/11.0f1e9ce2.jpg";